
import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component({
  name: "SvgImgv3"
})
export default class SvgImgV3 extends Vue {
  isView = true;
  @Prop({ type: String, default: "&#xe6c0;" }) icon!: string;
  @Prop({ type: String, default: "" }) videoId!: string;
  @Prop({ type: Boolean, default: false }) isEmitEvent!: boolean; //是否抛出点击事件
  @Prop({ type: Number, default: 56 }) width!: number; //宽高
  @Prop({ type: Number, default: 30 }) iconWidth!: number; //图标大小
  @Prop({ type: Boolean, default: false }) pauseShow!: boolean; // 显示暂停图标

  mounted() {
    this.targetVideo;
  }
  // 获取目标元素
  get targetVideo() {
    const video = document.querySelector(
      `#${this.videoId}`
    ) as HTMLVideoElement;
    this.addVideoEventListener(video);
    return video;
  }
  // 点击
  playEvent() {
    if (this.isEmitEvent) {
      this.$emit("videoPlay", this);
    } else {
      if (this.pauseShow && !this.isView) {
        this.targetVideo.pause();
      } else {
        this.targetVideo.play();
      }
    }
  }
  // 添加视频事件监听
  addVideoEventListener(video: HTMLVideoElement) {
    // play：播放监听
    video.addEventListener("play", this.playVideo);
    // pause：暂停监听
    video.addEventListener("pause", this.pauseVideo);
  }
  playVideo() {
    this.closeVideo();
    this.isView = false;
  }
  pauseVideo() {
    this.isView = true;
  }
  // 关闭当前之外的视频
  closeVideo() {
    this.$nextTick(() => {
      const videoList = Array.from(
        new Set(document.querySelectorAll("video") as NodeList)
      ) as HTMLVideoElement[];
      videoList.forEach((video: HTMLVideoElement) => {
        if (!(video.id === this.videoId)) video.pause();
      });
    });
  }

  beforeDestroy() {
    this.targetVideo.removeEventListener("play", this.playVideo);
    this.targetVideo.removeEventListener("pause", this.pauseVideo);
  }
}
